"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/sip-provision`;
    }
    /**
     * Creates SIP registration of a device/application (WebPhone, Mobile, Softphone).
   *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/client-info/sip-provision
     * Rate Limit Group: Heavy
     * App Permission: VoipCalling
     */
    async post(createSipRegistrationRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), createSipRegistrationRequest, undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map